import { render, staticRenderFns } from "./UpdateBusinessProfile.vue?vue&type=template&id=6a28b288&scoped=true&"
import script from "./UpdateBusinessProfile.vue?vue&type=script&lang=js&"
export * from "./UpdateBusinessProfile.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBusinessProfile.vue?vue&type=style&index=0&id=6a28b288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28b288",
  null
  
)

component.options.__file = "UpdateBusinessProfile.vue"
export default component.exports